<template>
  <v-app>
    <left-navigation-menu/>
    <top-navbar/>
    <v-content>
      <v-container fluid>
        <update-bar/>
        <v-flex
          md10
          xl8
          offset-md1
          offset-xl2>
          <router-view/>
        </v-flex>
      </v-container>
    </v-content>
    <content-footer/>
  </v-app>  
</template>

<script>
import TopNavbar from './TopNavbar.vue'
import UpdateBar from './UpdateBar.vue'
import ContentFooter from './ContentFooter.vue'
import LeftNavigationMenu from './LeftNavigationMenu.vue'

export default {
  components: {
    TopNavbar,
    UpdateBar,
    ContentFooter,
    LeftNavigationMenu,
  },
  created() {
    this.$store.dispatch('user/autoLogin')
  },
  methods: {},
}
</script>

<style lang="scss">

</style>
